// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"184ace83","787":"95ba70ce"}[chunkId] + ".chunk.js";
};